import request from './request'

export function getCompany() {
  return request.get('/sys/company')
}
export function saveCompany(data) {
  return request.post('/sys/company', data)
}

export function listUsers(params) {
  return request.get('/sys/users', { params })
}
export function saveUser(data) {
  return request.post('/sys/users', data)
}
export function deleteUser(id) {
  return request.delete(`/sys/users/${id}`)
}
export function resetUserPassword(id, password) {
  return request.post(`/sys/users/${id}/reset-password`, { password })
}

export function listRoles() {
  return request.get('/sys/roles')
}
export function saveRole(data) {
  return request.post('/sys/roles', data)
}
export function deleteRole(id) {
  return request.delete(`/sys/roles/${id}`)
}
export function getRoleMenus(id) {
  return request.get(`/sys/roles/${id}/menus`)
}
export function saveRoleMenus(id, menuIds) {
  return request.post(`/sys/roles/${id}/menus`, { menuIds })
}
export function copyRole(id, data) {
  return request.post(`/sys/roles/${id}/copy`, data)
}

export function listDepts() {
  return request.get('/sys/depts')
}
export function saveDept(data) {
  return request.post('/sys/depts', data)
}
export function deleteDept(id) {
  return request.delete(`/sys/depts/${id}`)
}

export function getSubscription() {
  return request.get('/sys/subscription')
}
export function getSubscriptionQuote(planCode) {
  return request.get('/sys/subscription/quote', { params: { planCode } })
}
export function createSubscriptionOrder(data) {
  return request.post('/sys/subscription/orders', data)
}
export function getSubscriptionOrder(orderNo) {
  return request.get(`/sys/subscription/orders/${orderNo}`)
}
export function submitPayNotice(data) {
  return request.post('/sys/subscription/pay-notice', data)
}
export function listPayNotices(params) {
  return request.get('/sys/subscription/pay-notices', { params })
}
export function confirmPayNotice(id) {
  return request.post(`/sys/subscription/pay-notices/${id}/confirm`)
}
export function rejectPayNotice(id, data) {
  return request.post(`/sys/subscription/pay-notices/${id}/reject`, data || {})
}
export function activatePlan(planCode, tenantCode) {
  return request.post('/sys/subscription/activate', { planCode, tenantCode })
}
export function submitInvoiceApply(data) {
  return request.post('/sys/subscription/invoice-apply', data)
}
export function listInvoiceApplies(params) {
  return request.get('/sys/subscription/invoice-applies', { params })
}
export function issueInvoiceApply(id, data) {
  return request.post(`/sys/subscription/invoice-applies/${id}/issue`, data || {})
}
export function getBillingAccount() {
  return request.get('/sys/billing-account')
}
export function saveBillingAccount(data) {
  return request.post('/sys/billing-account', data)
}

export function listParams() {
  return request.get('/sys/params')
}
export function getParamByCode(code) {
  return request.get('/sys/params/by-code', { params: { code } })
}
export function saveParam(data) {
  return request.post('/sys/params', data)
}

export function listAssignableMenus() {
  return request.get('/platform/menus/assignable')
}

export function listAppVersions(params) {
  return request.get('/sys/app-versions', { params })
}
export function saveAppVersion(data) {
  if (data.id) return request.put(`/sys/app-versions/${data.id}`, data)
  return request.post('/sys/app-versions', data)
}
export function deleteAppVersion(id) {
  return request.delete(`/sys/app-versions/${id}`)
}

export function listOpsTenants(params) {
  return request.get('/ops/tenants', { params })
}
export function disableOpsTenant(id) {
  return request.post(`/ops/tenants/${id}/disable`)
}
export function enableOpsTenant(id) {
  return request.post(`/ops/tenants/${id}/enable`)
}

export function getOpsMailConfig() {
  return request.get('/ops/mail-config')
}
export function saveOpsMailConfig(data) {
  return request.post('/ops/mail-config', data)
}
export function testOpsMail(data) {
  return request.post('/ops/mail-config/test', data)
}
